import { useEffect, useState } from 'react'
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  TextField, Button, Alert, CircularProgress,
} from '@mui/material'

// FAR-49: Create a Folder. Fields are Folder Name and Description; the server
// stamps the folder's Created timestamp, which drives FAR-54's "default to the
// newest folder" rule.
//
// Replaces the inline text field in FolderSelector, which had no Description
// and saved on blur -- so clicking away created a folder you hadn't finished
// naming.

const MAX_NAME = 120
const MAX_DESCRIPTION = 500

// A new folder defaults to today's date, matching what the server would use
// for a blank name.
const today = () => new Date().toISOString().slice(0, 10)

export default function CreateFolderModal({ open, onClose, onSubmit, loading, error }) {
  const [name, setName] = useState('')
  const [description, setDescription] = useState('')

  useEffect(() => {
    if (!open) return
    setName(today())
    setDescription('')
  }, [open])

  const trimmedName = name.trim()
  const valid = trimmedName.length > 0 && trimmedName.length <= MAX_NAME && description.length <= MAX_DESCRIPTION

  const submit = () => {
    if (!valid || loading) return
    onSubmit({ name: trimmedName, description: description.trim() })
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Create a Folder</DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2.5, pt: '16px !important' }}>
        {error && <Alert severity="error">{error}</Alert>}

        <TextField
          label="Folder Name"
          required
          value={name}
          onChange={(e) => setName(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') submit() }}
          inputProps={{ maxLength: MAX_NAME }}
          helperText={`${name.length}/${MAX_NAME}`}
          autoFocus
        />

        <TextField
          label="Description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          multiline
          rows={3}
          inputProps={{ maxLength: MAX_DESCRIPTION }}
          helperText={`Optional. ${description.length}/${MAX_DESCRIPTION}`}
        />
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} color="inherit">Cancel</Button>
        <Button
          onClick={submit}
          variant="contained"
          disabled={!valid || loading}
          startIcon={loading ? <CircularProgress size={18} /> : undefined}
        >
          Create Folder
        </Button>
      </DialogActions>
    </Dialog>
  )
}
